import { enumBinaCatalogItemElementType } from '@enum/enumBinaCatalogItemElementType';
import { enumBinaCatalogItemType } from '@enum/enumBinaCatalogItemType';

export interface BinaCatalogSupprtedTypeElementsModel {
  type: enumBinaCatalogItemType;
  elements: enumBinaCatalogItemElementType[];
}

export const BINA_CATALOG_SUPPORTED_TYPE_ELEMENT_LIST: BinaCatalogSupprtedTypeElementsModel[] = [
  {
    type: enumBinaCatalogItemType.UPDATED_AND_NOT_SUBJECT_TO_QUOTAS,
    elements: [
      enumBinaCatalogItemElementType.LEFT_COLUMN,
      enumBinaCatalogItemElementType.MIDDLE_COLUMN,
      enumBinaCatalogItemElementType.MIDDLE_COLUMN_HEADER,
      enumBinaCatalogItemElementType.MIDDLE_COLUMN_BODY,
      enumBinaCatalogItemElementType.MIDDLE_COLUMN_FOOTER,
      enumBinaCatalogItemElementType.RIGHT_COLUMN,
      enumBinaCatalogItemElementType.TITLE_EDIT_ICON,
      enumBinaCatalogItemElementType.BASED_ON_YOUR_SEARCH,
    ],
  },
  {
    type: enumBinaCatalogItemType.TARIFF_CHANGED,
    elements: [
      enumBinaCatalogItemElementType.LEFT_COLUMN,
      enumBinaCatalogItemElementType.MIDDLE_COLUMN,
      enumBinaCatalogItemElementType.MIDDLE_COLUMN_HEADER,
      enumBinaCatalogItemElementType.MIDDLE_COLUMN_BODY,
      enumBinaCatalogItemElementType.MIDDLE_COLUMN_FOOTER,
      enumBinaCatalogItemElementType.RIGHT_COLUMN,
      enumBinaCatalogItemElementType.TITLE_EDIT_ICON,
      enumBinaCatalogItemElementType.BASED_ON_YOUR_SEARCH,
    ],
  },
  {
    type: enumBinaCatalogItemType.SUBJECT_TO_QUOTAS,
    elements: [
      enumBinaCatalogItemElementType.LEFT_COLUMN,
      enumBinaCatalogItemElementType.MIDDLE_COLUMN,
      enumBinaCatalogItemElementType.MIDDLE_COLUMN_HEADER,
      enumBinaCatalogItemElementType.MIDDLE_COLUMN_BODY,
      enumBinaCatalogItemElementType.MIDDLE_COLUMN_FOOTER,
      enumBinaCatalogItemElementType.RIGHT_COLUMN,
      enumBinaCatalogItemElementType.TITLE_EDIT_ICON,
      enumBinaCatalogItemElementType.BASED_ON_YOUR_SEARCH,
    ],
  },
  {
    type: enumBinaCatalogItemType.HTS_NO_LONGER_VALID,
    elements: [
      enumBinaCatalogItemElementType.LEFT_COLUMN,
      enumBinaCatalogItemElementType.MIDDLE_COLUMN,
      enumBinaCatalogItemElementType.MIDDLE_COLUMN_HEADER,
      enumBinaCatalogItemElementType.MIDDLE_COLUMN_BODY,
      enumBinaCatalogItemElementType.MIDDLE_COLUMN_FOOTER,
      enumBinaCatalogItemElementType.RIGHT_COLUMN,
      enumBinaCatalogItemElementType.TITLE_EDIT_ICON,
      enumBinaCatalogItemElementType.BASED_ON_YOUR_SEARCH,
    ],
  },
];
